module.exports = __webpack_public_path__ + "img/spc-navbar-mobile.b86169a.png";